<script>
    import Content from '@/services/Content'
    import General from '@/services/General'
    import BusinessNewsAudienceTargeting from '@/components/business/BusinessNewsAudienceTargeting'
    import validationMessages from '@/components/validations'
    import { required, numeric, requiredIf, url  } from "vuelidate/lib/validators";
    import CKEditor from '@ckeditor/ckeditor5-vue2';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import Sortable from 'sortablejs';
    import moment from 'moment';
    import {
      buildDefaultFieldAttributes,
      normalizeAdditionalFieldsForApi,
      validateAdditionalSections,
      detectParamInputType,
    } from '@/helpers/businessEventFieldAttributes';
    export default {
        components:{
            validationMessages,
            BusinessNewsAudienceTargeting,
            ckeditor: CKEditor.component,
            flatPickr,
        },
        data() {
            return {
              csrf_token: localStorage.getItem('csrf_token'),
                showModal: false,
                tryingToSubmit: false,
                submitted: false,
                event: {
                start_at: '',
                register_by: '',
                event_limit:null,
                user_limit: null,
                company_limit: null,
                location:'',
                toc: '',
                external_registration: 0,
                external_registration_url: '',
              },
              externalRegistration: false,
              date: '',
              time: '',
              registerByDate: '',
              registerByTime: '',
              published: moment().format('YYYY-MM-DD HH:mm'),
              publishedDate: moment().format('YYYY-MM-DD'),
              publishedTime: moment().format('HH:mm'),
                title: "",
                content: "",
                image:"",
                file:null,
                content_type: "event",
                acceptedFileTypeErrorMessage:'',
                acceptedFileTypeError:false,
                acceptedFileSizeErrorMessage:'',
                acceptedFileSizeError:false,
                image_removed: false,
                editor: ClassicEditor,
                editorData: '',
                dateconfig: {
                    enableTime: false,
                    dateFormat: "Y-m-d", 
                    minDate: new Date(), 
                },
                timeconfig: {
                    enableTime: true,
                    noCalendar: true,
                    time_24hr: true,
                    minuteIncrement: 1,
                    dateFormat: "H:i",
                    allowInput: true,
                },
                publishedDateconfig: {
                    enableTime: false,
                    dateFormat: "Y-m-d",
                    minDate: "today",
                },
                publishedTimeconfig: {
                    enableTime: true,
                    noCalendar: true,
                    time_24hr: true,
                    minuteIncrement: 1,
                    dateFormat: "H:i",
                    allowInput: true,
                },
                editorConfig: {
                    toolbar: [
                        'heading',
                        '|',         // ← add this
                        'bold', 'italic',     // basic styles
                        'link',               // link button
                        '|',
                        'bulletedList', 'numberedList',
                        'blockQuote',
                        '|',
                        'undo', 'redo',
                    ],
                },
              accepted_file_types: ['image/jpeg', 'image/png','image/gif','image/webp','image/bmp'],
              accepted_file_size:'4096',
              fields_definition:{},
              additional_field_options:[],
              field_type:'',
              show_select_field_type: false,
              sectionIdCounter: 0,
              additional_sections: [],
              showCheckedIcon:false,
              showNotCheckedIcon:true,
              isDragOver: false,
              savedSections: [],
              sortableInstance: null,
              appButtonColor: '#e30613',
              appButtonTextColor: '#ffffff',
              previewFieldValues: {},
              skipShowInit: false,
              copySource: null,
              copyImageUrl: '',
              isCopyMode: false,
            };

        },
        
       validations () {
         return {
           title: { required },
           content: { required },
           published: { required },
           event: {
             start_at: { required },
             event_limit: { numeric },
             // user_limit: { numeric },
             // company_limit: { numeric },
             location: { required },
             // toc: { required, url },
             external_registration_url: {
               required: requiredIf(function () { return this.externalRegistration; }),
               url,
             },
           },
           additional_sections: {
             $each: {
               field_type: { required: requiredIf(function () { return !this.externalRegistration && this.show_select_field_type }) },
           //    name: { required: requiredIf(function () { return this.show_select_field_type }) },
               label: { required: requiredIf(function () { return !this.externalRegistration && this.show_select_field_type }) }
             }
           }
         }
       },
       async created() {
        await this.loadAppButtonColors();
       },

       watch: {
         field_type(newType) {
           if (!newType) return
           const def = this.fields_definition[newType]
           if (def && def.required_params) {
             const params = JSON.parse(def.required_params)
             this.field_attributes = {}
             params.forEach(p => {
               this.field_attributes[p.param] = p.param_type === "array" ? [""] : ""
             })
           }
         },
         date() {
           this.updateStartAt();
           this.syncRegisterByWithEventDate();
         },
         time() {
           this.updateStartAt();
           // Keep default register-by aligned with event time until user picks a different date
           if (this.registerByDate && this.registerByDate === this.date) {
             this.registerByTime = this.time || '';
             this.updateRegisterBy();
           }
         },
         registerByDate() {
           this.updateRegisterBy();
         },
         registerByTime() {
           this.updateRegisterBy();
         },
         publishedDate() {
           this.updatePublished();
         },
         publishedTime() {
           this.updatePublished();
         },
         externalRegistration(isExternal) {
           this.event.external_registration = isExternal ? 1 : 0;
           if (!isExternal) {
             this.event.external_registration_url = '';
           }
         },
       },

        computed: {
          registerByDateConfig() {
            return {
              enableTime: false,
              dateFormat: 'Y-m-d',
              minDate: new Date(),
              maxDate: this.date || null,
            };
          },
          validationErrors() {
            const errors = [];
            if (this.$v.title.$invalid) errors.push('Event Name is required.');
            if (this.$v.published.$invalid) errors.push('Published Date is required.');
            // Event fields
            if (this.$v.event.start_at.$invalid) errors.push('Date and Time is required.');
            if (this.$v.event.location.$invalid) errors.push('Location is required.');
            // if (this.$v.event.toc.$invalid) errors.push('Terms and Conditions is required.');
            if ((this.registerByDate && !this.registerByTime) || (!this.registerByDate && this.registerByTime)) {
              errors.push('Register By requires both date and time.');
            }
            if (this.event.register_by && this.event.start_at) {
              const registerByTs = moment(this.event.register_by, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD']);
              const startAtTs = moment(this.event.start_at, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD']);
              if (registerByTs.isValid() && startAtTs.isValid() && registerByTs.isAfter(startAtTs)) {
                errors.push('Register By must be before or equal to the event date/time.');
              }
            }
            if (this.externalRegistration) {
              if (this.$v.event.external_registration_url.$invalid) {
                errors.push(
                  !this.event.external_registration_url
                    ? 'External Registration URL is required.'
                    : 'External Registration URL must be a valid URL.'
                );
              }
            } else {
              // numeric fields
              // if (this.$v.event.user_limit.$invalid) errors.push('User Limit must be a number.');
              // if (this.$v.event.company_limit.$invalid) errors.push('Company Limit must be a number.');
              if (this.$v.event.event_limit.$invalid) errors.push('Event Limit must be a number.');

              if(this.showCheckedIcon){
                  errors.push(...validateAdditionalSections(this.additional_sections, this.fields_definition));
              }
            }
            return errors;
          },
          previewAdditionalFields() {
            if (this.externalRegistration) {
              return [];
            }
            return this.additional_sections.filter((section) => {
              if (!section.field_type) return false;
              const def = this.fields_definition[section.field_type];
              return def && def.active !== 0;
            });
          },
        },

        methods: {
            openDatePicker() {
              this.$refs.datePicker.$el.click();
            },
            openTimePicker() {
              this.$refs.timePicker.$el.click();
            },
            openPublishedDatePicker() {
              this.$refs.publishedDatePicker.$el.click();
            },
            openPublishedTimePicker() {
              this.$refs.publishedTimePicker.$el.click();
            },
            openRegisterByDatePicker() {
              this.$refs.registerByDatePicker.$el.click();
            },
            openRegisterByTimePicker() {
              this.$refs.registerByTimePicker.$el.click();
            },
            triggerFileInput() {
              this.$refs['file-input'].click();
            },
            handleFileDrop(event) {
              this.isDragOver = false;
              const files = event.dataTransfer && event.dataTransfer.files;
              if (files && files.length > 0) {
                this.file = files[0];
                this.copyImageUrl = '';
                // Create preview URL
                if (this.image && this.image.startsWith('blob:')) {
                  URL.revokeObjectURL(this.image);
                }
                this.image = URL.createObjectURL(this.file);
              }
            },
            updateStartAt() {
              if (this.date && this.time) {
                this.event.start_at = `${this.date} ${this.time}`;
              } else if (this.date) {
                this.event.start_at = this.date;
              } else {
                this.event.start_at = '';
              }
            },
            updatePublished() {
              if (this.publishedDate && this.publishedTime) {
                this.published = `${this.publishedDate} ${this.publishedTime}`;
              } else if (this.publishedDate) {
                this.published = this.publishedDate;
              } else {
                this.published = '';
              }
            },
            setDefaultPublishedDateTime() {
              const date = moment().format('YYYY-MM-DD');
              const time = moment().format('HH:mm');
              this.publishedDate = date;
              this.publishedTime = time;
              this.updatePublished();
              this.$nextTick(() => {
                if (this.$refs.publishedDatePicker && this.$refs.publishedDatePicker.fp) {
                  this.$refs.publishedDatePicker.fp.setDate(date, true);
                }
                if (this.$refs.publishedTimePicker && this.$refs.publishedTimePicker.fp) {
                  this.$refs.publishedTimePicker.fp.setDate(time, true);
                }
              });
            },
            updateRegisterBy() {
              if (this.registerByDate && this.registerByTime) {
                this.event.register_by = `${this.registerByDate} ${this.registerByTime}`;
              } else if (this.registerByDate) {
                this.event.register_by = this.registerByDate;
              } else {
                this.event.register_by = '';
              }
            },
            syncRegisterByWithEventDate() {
              this.registerByDate = this.date || '';
              this.registerByTime = this.time || '';
              this.updateRegisterBy();
            },
            refreshBusinessData() { 
                this.$emit('refreshScreen') //event from parent
            },

            openWithCopy(source) {
                this.skipShowInit = true;
                this.isCopyMode = true;
                this.copySource = source ? { ...source } : null;
                this.$bvModal.show('add_business_event');
            },

            buildCopyTitle(title) {
                        const baseTitle = (title || '').trim();
                        if (!baseTitle) {
                            return '';
                        }

                        return baseTitle.startsWith('Copy of ')
                            ? baseTitle
                            : `Copy of ${baseTitle}`;
                    },

            splitStartAt(startAt) {
                if (!startAt) {
                    return { date: '', time: '' };
                }

                const m = moment(
                    String(startAt).trim(),
                    ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD'],
                    true
                );
                const datetime = m.isValid()
                    ? m
                    : moment(String(startAt).trim().replace(' ', 'T'));

                if (!datetime.isValid()) {
                    return { date: '', time: '' };
                }

                return {
                    date: datetime.format('YYYY-MM-DD'),
                    time: datetime.format('HH:mm'),
                };
            },

            isPastStartAt(startAt) {
                if (!startAt) {
                    return false;
                }

                const m = moment(
                    String(startAt).trim(),
                    ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD'],
                    true
                );
                const datetime = m.isValid()
                    ? m
                    : moment(String(startAt).trim().replace(' ', 'T'));

                return datetime.isValid() && datetime.isBefore(moment());
            },

            clearDateTimeFields() {
                this.date = '';
                this.time = '';
                this.event.start_at = '';
                this.$nextTick(() => {
                    if (this.$refs.datePicker && this.$refs.datePicker.fp) {
                        this.$refs.datePicker.fp.clear();
                    }
                    if (this.$refs.timePicker && this.$refs.timePicker.fp) {
                        this.$refs.timePicker.fp.clear();
                    }
                });
            },

            async populateFromCopy(source) {
                if (!source) {
                    return;
                }

                const eventInfo = source.event_info || {};
                const startAt = eventInfo.start_at || source.start_at || '';
                const shouldClearDateTime = this.isPastStartAt(startAt);
                const usableStartAt = shouldClearDateTime ? '' : startAt;
                const { date, time } = this.splitStartAt(usableStartAt);

                this.title = this.buildCopyTitle(source.title);
                this.content = source.original_content || '';
                this.copyImageUrl = source.image || '';
                this.image = this.copyImageUrl;
                this.file = null;
                const registerByRaw = eventInfo.register_by || source.register_by || '';
                const registerByParts = this.splitStartAt(registerByRaw);

                this.event = {
                    start_at: usableStartAt,
                    register_by: '',
                    event_limit: eventInfo.registrationLimit ?? eventInfo.event_limit ?? null,
                    user_limit: eventInfo.userLimit ?? eventInfo.user_limit ?? null,
                    company_limit: eventInfo.companyLimit ?? eventInfo.company_limit ?? null,
                    location: eventInfo.location || source.location || '',
                    toc: eventInfo.toc || source.toc || '',
                };

                if (shouldClearDateTime) {
                    this.clearDateTimeFields();
                    this.registerByDate = '';
                    this.registerByTime = '';
                    this.updateRegisterBy();
                } else {
                    this.date = date;
                    this.time = time;
                    this.updateStartAt();
                    this.registerByDate = registerByParts.date || date;
                    this.registerByTime = registerByParts.time || time;
                    if (this.date && this.registerByDate && this.registerByDate > this.date) {
                      this.registerByDate = this.date;
                      this.registerByTime = this.time || this.registerByTime;
                    }
                    this.updateRegisterBy();
                }

                const eventFields = Array.isArray(eventInfo.event_fields) ? eventInfo.event_fields : [];
                if (eventFields.length > 0) {
                    this.show_select_field_type = true;
                    this.showCheckedIcon = true;
                    this.showNotCheckedIcon = false;
                    await this.fetchBusinessEventFieldsDefinition();

                    this.additional_sections = eventFields.map((field, idx) => {
                        const attrs = {};
                        if (field.attributes && typeof field.attributes === 'object') {
                            Object.keys(field.attributes).forEach((attrKey) => {
                                attrs[attrKey] = field.attributes[attrKey] || '';
                            });
                        }

                        return {
                            _id: idx,
                            field_type: field?.input_type || '',
                            name: field?.name || '',
                            label: field?.label || '',
                            required: field?.is_required ? 1 : 0,
                            field_attributes: attrs,
                        };
                    });
                    this.savedSections = this.additional_sections.map(() => true);
                    this.sectionIdCounter = this.additional_sections.length;
                    this.additional_sections.forEach((section) => {
                        this.initPreviewFieldValue(section);
                    });
                } else {
                    this.show_select_field_type = false;
                    this.showCheckedIcon = false;
                    this.showNotCheckedIcon = true;
                    this.additional_sections = [];
                    this.savedSections = [];
                    this.sectionIdCounter = 0;
                    await this.fetchBusinessEventFieldsDefinition();
                }

                const labels = Array.isArray(source.labels) ? source.labels : [];
                const groups = Array.isArray(source.groups) ? source.groups : [];
                this.$nextTick(async () => {
                    if (this.$refs.audienceTargeting) {
                        await this.$refs.audienceTargeting.onShown();
                        await this.$refs.audienceTargeting.loadFromInitialAudience({
                            labels,
                            groups,
                            audience_type: source.audience_type || '',
                            audience_operator: source.audience_operator || 'OR',
                        });
                    }
                });
            },
      
            async addBusinessEvent() {
                if(this.acceptedFileTypeError || this.acceptedFileSizeError) return;
                this.tryingToSubmit = true;
                this.submitted = true;
                this.$v.$touch(); // Trigger validations

                if (this.$v.$invalid || this.validationErrors.length) {
                  if (this.validationErrors.length) {
                    this.failedmsg(this.validationErrors[0]);
                  }
                  this.tryingToSubmit = false;
                  return;
            }

            const audienceError = this.$refs.audienceTargeting.validate();
            if (audienceError) {
              this.failedmsg(audienceError);
              this.tryingToSubmit = false;
              return;
            }

            const formData = new FormData();
            formData.append('title', this.title);
            formData.append('content', this.content);
            if (this.file) {
              formData.append('image', this.file);
            } else if (this.copyImageUrl) {
              formData.append('image', this.copyImageUrl);
            }
            formData.append('content_type', this.content_type);
            formData.append('csrf_token', this.csrf_token);
            formData.append('active', 1);
            formData.append('type', 'dash');
            formData.append('published', this.published);

            const eventData = {
              start_at: this.event.start_at,
              register_by: this.event.register_by || null,
              location: this.event.location,
              external_registration: this.externalRegistration ? 1 : 0,
              external_registration_url: this.externalRegistration
                ? (this.event.external_registration_url || null)
                : null,
              user_limit: this.externalRegistration ? null : this.event.user_limit,
              event_limit: this.externalRegistration ? null : this.event.event_limit,
              company_limit: this.externalRegistration ? null : this.event.company_limit,
              toc: this.externalRegistration ? '' : this.event.toc,
              additional_fields: (!this.externalRegistration && this.show_select_field_type)
                ? normalizeAdditionalFieldsForApi(this.additional_sections)
                : {},
            };
            formData.append('event', JSON.stringify(eventData));
            this.$refs.audienceTargeting.appendToCreateFormData(formData);

            Content.addBusinessNews(formData)
                .then(() => {
                  this.successmsg("Business Event Created!");
                  this.closeModal();
                  this.refreshBusinessData();
                })
                .catch((error) => {
                  const errorMsg = error.response?.data?.error || "Failed to create business event";
                  this.failedmsg(errorMsg);
                })
                .finally(() => {
                  this.tryingToSubmit = false;
                });
            },
            closeModal() {
                this.showModal = false;
            },
            selectFile(event) {
              const file = event.target.files && event.target.files[0];
              this.file = file || null;
              this.copyImageUrl = '';
              if (file) {
                // Create preview URL
              if (this.image && this.image.startsWith('blob:')) {
                URL.revokeObjectURL(this.image);
              }
                this.image = URL.createObjectURL(file);
              }
            },
            removeImage() {
              this.file = null;
              this.copyImageUrl = '';
              if (this.image && this.image.startsWith('blob:')) {
                URL.revokeObjectURL(this.image);
              }
              this.image = "";
              if (this.$refs['file-input']) {
                this.$refs['file-input'].value = '';
              }
            },
          

            resetProps() {
               this.submitted = false;
               this.title = '';
               this.content = '';
               if (this.image && this.image.startsWith('blob:')) {
                 URL.revokeObjectURL(this.image);
               }
               this.image = '';
               this.file=null;
               this.show_select_field_type = false,
               this.showCheckedIcon = false,
               this.showNotCheckedIcon = true,
               this.isDragOver = false,
               this.field_type = '',
               this.additional_field_options=[],
               this.sectionIdCounter = 0,
               this.additional_sections = [],
               this.savedSections = [],
              this.previewFieldValues = {},
              this.copySource = null,
              this.copyImageUrl = '',
              this.isCopyMode = false,
              this.skipShowInit = false,
              this.destroySortable(),
               this.event = {
                start_at: '',
                register_by: '',
                event_limit: null,
                user_limit: null,
                company_limit: null,
                location:'',
                toc: '',
                external_registration: 0,
                external_registration_url: '',
              };
              this.externalRegistration = false;
              this.date = '';
              this.time = '';
              this.registerByDate = '';
              this.registerByTime = '';
              this.setDefaultPublishedDateTime();
              if (this.$refs.audienceTargeting) {
                this.$refs.audienceTargeting.reset();
              }

            },

            async fetchBusinessEventFieldsDefinition() {
               const response = await Content.getBusinessEventFieldsDefinition();
               this.fields_definition = response.data.data;
               this.additional_field_options = Object.keys(this.fields_definition).map(k => ({
                 value: k,
                 text: this.fields_definition[k].description
               }));
            },

            async getBusinessEventFieldsDefinition() {
                await this.fetchBusinessEventFieldsDefinition();
                this.show_select_field_type = true;
                this.showCheckedIcon = true;
                this.showNotCheckedIcon = false;
                
                // Auto-select first field type for the first section
                if (
                  this.additional_sections.length > 0 &&
                  this.additional_field_options.length > 0 &&
                  !this.additional_sections[0].field_type
                ) {
                  this.additional_sections[0].field_type = this.additional_field_options[0].value;
                  this.onFieldTypeChange(this.additional_sections[0]);
                }
            },

            async modalShown() {
              if (this.skipShowInit) {
                const source = this.copySource;
                this.skipShowInit = false;
                this.copySource = null;
                if (source) {
                  await this.populateFromCopy(source);
                }
              } else {
                this.isCopyMode = false;
                this.copyImageUrl = '';
                this.setDefaultPublishedDateTime();
                await this.getBusinessEventFieldsDefinition();
                if (this.$refs.audienceTargeting) {
                  await this.$refs.audienceTargeting.onShown();
                }
              }
              this.$nextTick(() => {
                this.initSortable();
              });
            },

            addSection() {
              const newSection = {
                _id: this.sectionIdCounter++,
                field_type: '',
                name: '',
                label: '',
                required: 1,
                field_attributes: {}
              };
              
              // Auto-select first field type if available
              if (this.additional_field_options && this.additional_field_options.length > 0) {
                newSection.field_type = this.additional_field_options[0].value;
              }
              
              this.additional_sections.push(newSection);
              
              // Ensure the new section is visible (not saved/collapsed)
              this.savedSections.push(false);
              
              // Initialize field attributes if field_type is set
              if (newSection.field_type) {
                this.onFieldTypeChange(newSection);
              } else {
                this.initPreviewFieldValue(newSection);
              }

              // touch validations after next tick and scroll to new field
              this.$nextTick(() => {
                this.$v.additional_sections.$touch();
                
                // Scroll to the newly added field to ensure it's visible
                const container = document.getElementById('additional-fields-container');
                if (container) {
                  const lastField = container.lastElementChild;
                  if (lastField) {
                    lastField.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                  }
                }
              });
            },

            removeSection(index) {
              const section = this.additional_sections[index];
              if (section) {
                this.clearPreviewFieldValue(section._id);
              }
              this.additional_sections.splice(index, 1);
              // Also remove the corresponding savedSections entry
              if (this.savedSections[index] !== undefined) {
                this.savedSections.splice(index, 1);
              }
              // Reinit sortable after removing a section
              this.$nextTick(() => {
                this.destroySortable();
                this.initSortable();
                this.$v.additional_sections.$touch();
              });
            },

            addAdditionalFields(){
               this.show_select_field_type = !this.show_select_field_type;
               this.showCheckedIcon = !this.showCheckedIcon;
               this.showNotCheckedIcon = !this.showNotCheckedIcon;

               if (this.show_select_field_type) {
                   this.getBusinessEventFieldsDefinition();
               }
            },

             addAdditionalField() {
                if (!this.field_type) return;
                const def = this.fields_definition[this.field_type];
                if (def && def.required_params) {
                  const params = JSON.parse(def.required_params);
                  const field_attributes = {};
                  params.forEach(p => {
                    field_attributes[p.param] = p.param_type === "array" ? [""] : "";
                  });

                  this.additional_fields.push({
                    field_type: this.field_type,
                    name: this.name,
                    label: this.label,
                    required:this.required,
                    field_attributes
                  });
                }
                // Reset selection so user can pick another type
                this.field_type = '';
                this.name = '';
                this.label = '';
             },

            onFieldTypeChange(section) {
              const def = this.fields_definition[section.field_type];
              if (!def || !def.required_params) {
                section.field_attributes = null;
                return;
              }

              section.field_attributes = buildDefaultFieldAttributes(def);
              this.initPreviewFieldValue(section);
            },

           previewInputType(section) {
             if (!section || !section.field_type) return 'text';

             const fieldKey = String(section.field_type).trim();
             const def = this.fields_definition[fieldKey];
             const rawType = (def && def.input_type) ? def.input_type : fieldKey;
             const normalized = String(rawType).toLowerCase().replace(/-/g, '_');

             if (normalized === 'radio' || fieldKey === 'radio') return 'radio';
             if (normalized === 'multi_select' || fieldKey === 'multi_select') return 'multi_select';
             if (normalized === 'select' || fieldKey === 'select') return 'select';
             if (normalized === 'textarea' || fieldKey === 'textarea') return 'textarea';
             if (normalized === 'text' || fieldKey === 'text') return 'text';

             return 'text';
           },

           initPreviewFieldValue(section) {
             if (!section || section._id == null) return;

             const type = this.previewInputType(section);
             if (type === 'multi_select') {
               this.$set(this.previewFieldValues, section._id, []);
             } else if (type === 'radio') {
               this.$set(this.previewFieldValues, section._id, null);
             } else if (this.previewFieldValues[section._id] !== undefined) {
               this.$delete(this.previewFieldValues, section._id);
             }
           },

           clearPreviewFieldValue(sectionId) {
             if (this.previewFieldValues[sectionId] !== undefined) {
               this.$delete(this.previewFieldValues, sectionId);
             }
           },

           detectInputType(section, key) {
               const def = this.fields_definition[section.field_type];
               return detectParamInputType(def, key);
             },

           getParamDescription(section, key) {
             //No section or no type picked yet
             if (!section || !section.field_type) return key;

             //Get the definition for this sections type
             const def = this.fields_definition[section.field_type];
             if (!def || !def.required_params) return key;

             //required_params is a JSON string from the API
             let params = [];
             try {
               params = JSON.parse(def.required_params || "[]");
             } catch (e) {
               return key;
             }

             //Find this params schema
             const spec = params.find(p => p.param === key);
             return spec && spec.description ? spec.description : key;
           },

           getPreviewInputType(section) {
             return this.previewInputType(section);
           },

           getPreviewFieldPlaceholder(section) {
             const attrs = section.field_attributes || {};
             return attrs.placeholder || '';
           },

           getPreviewTextareaRows(section) {
             const attrs = section.field_attributes || {};
             const rows = parseInt(attrs.rows, 10);
             return Number.isFinite(rows) && rows > 0 ? rows : 4;
           },

           getPreviewFieldOptions(section) {
             const attrs = section.field_attributes || {};
             const options = attrs.options;
             if (!Array.isArray(options)) return [];
             return options
               .map((opt) => String(opt || '').trim())
               .filter(Boolean);
           },

           saveAdditionalField(index) {
             // Mark this section as saved
             this.$set(this.savedSections, index, true);
             // Reinit sortable after adding a saved section
             this.$nextTick(() => {
               this.destroySortable();
               this.initSortable();
             });
           },

           expandField(index) {
             // Set to false to show the form again (don't delete to maintain index alignment)
             this.$set(this.savedSections, index, false);
             // Reinit sortable after removing a saved section
             this.$nextTick(() => {
               this.destroySortable();
               this.initSortable();
             });
           },
           async loadAppButtonColors() {
             try {
               const colors = await General.getAppButtonColors();
               Object.assign(this, colors);
             } catch (error) {
               // keep default colors if request fails
             }
           },
           initSortable() {
             this.$nextTick(() => {
               const container = document.getElementById('additional-fields-container');
               if (container) {
                 // Destroy existing instance if any
                 if (this.sortableInstance) {
                   this.sortableInstance.destroy();
                 }
                 
                 this.sortableInstance = Sortable.create(container, {
                   handle: '.drag-handle',
                   animation: 150,
                   ghostClass: 'sortable-ghost',
                   filter: '.no-drag',
                   preventOnFilter: false,
                   onEnd: (evt) => {
                     // Reorder sections to match the new DOM order
                     if (
                       evt.oldIndex != null &&
                       evt.newIndex != null &&
                       evt.oldIndex !== evt.newIndex
                     ) {
                       const movedSection = this.additional_sections.splice(evt.oldIndex, 1)[0];
                       this.additional_sections.splice(evt.newIndex, 0, movedSection);

                       const movedSaved = this.savedSections.splice(evt.oldIndex, 1)[0];
                       this.savedSections.splice(evt.newIndex, 0, movedSaved);
                     }
                   }
                 });
               }
             });
           },

           destroySortable() {
             if (this.sortableInstance) {
               this.sortableInstance.destroy();
               this.sortableInstance = null;
             }
           }
        },
    };
</script>

<template>
    <b-modal id="add_business_event" size="xl" v-model="showModal" @hidden="resetProps" @shown="modalShown" title-class="font-18" no-enforce-focus>
    <template v-slot:modal-header>
      <div class="w-100">
        <h5 class="modal-title mb-0">{{ isCopyMode ? 'Copy Business Event' : 'Create Business Event' }}</h5>
        <p class="text-muted mb-0 mt-2">
          {{ isCopyMode ? 'Review and save a copy of this business event' : 'Set up a new event for your business club members' }}
        </p>
      </div>
      <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
    </template>
    <form @submit.prevent="addBusinessEvent">
      <div class="row">
        <!-- Left side: form and configuration -->
        <div class="col-lg-7">
          <div class="card mb-3">
            <div class="card-body py-2">
              <h4 class="card-title mb-1">Basic Information</h4>
              <p class="text-muted mb-3">Essential details about your event</p>
              <div class="mb-2">
                <label class="mb-1">Event Name *</label>
                <b-form-input v-model="title" placeholder="e.g., Executive Networking Dinner"></b-form-input>
              </div>
              <validationMessages 
                    v-if="submitted"
                    :fieldName="'Event Name'"
                    :validationName="$v.title">
              </validationMessages>
              <div class="row mb-2">
                <div class="col-md-4">
                  <label class="mb-1"> <i class="uil uil-map-marker me-1"></i>Location * </label>
                  <b-form-input v-model="event.location" placeholder="e.g., Stadium VIP Lounge"></b-form-input>
                </div>
                <div class="col-md-4">
                  <label class="mb-1">
                    <i class="uil uil-calendar-alt me-1"></i>Date *
                  </label>
                  <div class="position-relative">
                    <flat-pickr
                      ref="datePicker"
                      v-model="date"
                      :config="dateconfig"
                      class="form-control pe-4"
                      name="date"
                    />
                    <i class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted" 
                       style="cursor: pointer; pointer-events: all;"
                       @click="openDatePicker"></i>
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="mb-1">
                    <i class="uil uil-clock me-1"></i>Time *
                  </label>
                  <div class="position-relative">
                    <flat-pickr
                      ref="timePicker"
                      v-model="time"
                      :config="timeconfig"
                      class="form-control pe-4"
                      name="time"
                    />
                    <i class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted" 
                       style="cursor: pointer; pointer-events: all;"
                       @click="openTimePicker"></i>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-4">
                  <label class="mb-1">
                    <i class="uil uil-calendar-alt me-1"></i>Published Date *
                  </label>
                  <div class="position-relative">
                    <flat-pickr
                      ref="publishedDatePicker"
                      v-model="publishedDate"
                      :config="publishedDateconfig"
                      class="form-control pe-4"
                      name="publishedDate"
                    />
                    <i
                      class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                      style="cursor: pointer; pointer-events: all;"
                      @click="openPublishedDatePicker"
                    ></i>
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="mb-1">
                    <i class="uil uil-clock me-1"></i>Published Time *
                  </label>
                  <div class="position-relative">
                    <flat-pickr
                      ref="publishedTimePicker"
                      v-model="publishedTime"
                      :config="publishedTimeconfig"
                      class="form-control pe-4"
                      name="publishedTime"
                    />
                    <i
                      class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                      style="cursor: pointer; pointer-events: all;"
                      @click="openPublishedTimePicker"
                    ></i>
                  </div>
                </div>
              </div>
              <validationMessages
                    v-if="submitted"
                    :fieldName="'Location'"
                    :validationName="$v.event.location">
              </validationMessages>
              <validationMessages
                v-if="submitted"
                :fieldName="'Date and Time'"
                :validationName="$v.event.start_at"
              ></validationMessages>
              <validationMessages
                v-if="submitted"
                :fieldName="'Published Date'"
                :validationName="$v.published"
              ></validationMessages>
            </div>
          </div>
          <div class="card mb-3">
            <div class="card-body py-2">
              <h4 class="card-title mb-1">
                <i class="uil uil-image me-2"></i>Header Image
              </h4>
              <p class="text-muted mb-3">Upload a banner image for the event page (recommended: 1200x400px)</p>
              <b-form-group label-for="image" class="mb-3">
                <!-- Image Preview -->
                <div v-if="image" class="mb-3">
                  <div class="image-preview-container position-relative" style="width: 100%; min-height: 200px; background: #f8f9fa; border-radius: 8px; overflow: hidden;">
                    <img :src="image" alt="Preview" style="width: 100%; height: 100%; object-fit: cover;">
                    
                    <!-- Text Overlay (Bottom Left) -->
                    <div class="position-absolute" style="bottom: 15px; left: 15px; background: rgba(0,0,0,0.6); color: white; padding: 8px 12px; border-radius: 4px;">
                      <div style="font-size: 14px; font-weight: 600; margin-bottom: 2px;">Header Image Preview</div>
                      <div style="font-size: 12px; opacity: 0.9;">This is how your image will appear</div>
                    </div>
                    
                    <!-- Remove Button (Bottom Right) -->
                    <button 
                      type="button" 
                      @click="removeImage" 
                      class="btn btn-sm position-absolute"
                      style="bottom: 15px; right: 15px; background: rgba(255,255,255,0.95); border: 1px solid #dee2e6; color: #495057; font-size: 12px; padding: 4px 12px; display: flex; align-items: center;"
                    >
                      <i class="uil uil-times me-1"></i>Remove
                    </button>
                  </div>
                </div>
                
                <!-- Upload Area -->
                <div 
                  v-if="!image"
                  class="upload-area text-center position-relative"
                  :class="{'border-primary': isDragOver}"
                  @dragover.prevent="isDragOver = true"
                  @dragleave.prevent="isDragOver = false"
                  @drop.prevent="handleFileDrop"
                  style="
                    cursor: pointer;
                    min-height: 220px;
                    display: flex; flex-direction: column; justify-content: center; align-items: center;
                    border: 2px dashed #cbd5e1;
                    border-radius: 12px;
                    padding: 28px;
                    background: #fff;
                  "
                  @click="triggerFileInput"
                >
                  <div style="
                    width: 72px; height: 72px; border-radius: 9999px;
                    background: #eef2ff; display: flex; align-items: center; justify-content: center;
                    margin-bottom: 12px;
                  ">
                    <i class="uil uil-upload" style="font-size: 28px; color: #6b7280;"></i>
                  </div>
                  <div class="mb-1" style="font-weight: 500; color: #111827;">
                    Drag and drop an image, or click to browse
                  </div>
                  <div class="text-muted mb-3" style="font-size: 13px;">
                    PNG, JPG up to 10MB
                  </div>
                  <button type="button" class="btn btn-light btn-sm" @click.stop="triggerFileInput">
                    <i class="uil uil-upload me-1"></i>
                    Choose File
                  </button>
                  <input 
                    ref="file-input" 
                    type="file" 
                    @change="selectFile" 
                    accept="image/*" 
                    style="display: none;"
                  />
                </div>
              </b-form-group>
            </div>

          </div>

          <div class="card mb-3">
            <div class="card-body py-2">
              <h4 class="card-title mb-1">
                <i class="uil uil-ticket me-2"></i>Registration Type
              </h4>
              <p class="text-muted mb-3">Choose how attendees register for this event</p>
              <div class="d-flex align-items-center flex-wrap mb-3" style="gap: 12px;">
                <span
                  class="mb-0"
                  :style="{ fontWeight: externalRegistration ? 400 : 600, color: externalRegistration ? '#6c757d' : '#212529' }"
                >
                  App Registration
                </span>
                <div class="form-check form-switch form-switch-lg mb-0">
                  <input
                    id="externalRegistrationSwitch"
                    v-model="externalRegistration"
                    type="checkbox"
                    class="form-check-input"
                  />
                </div>
                <span
                  class="mb-0"
                  :style="{ fontWeight: externalRegistration ? 600 : 400, color: externalRegistration ? '#212529' : '#6c757d' }"
                >
                  External Registration
                </span>
              </div>
              <div v-if="externalRegistration">
                <b-form-group label-for="externalRegistrationUrl" class="mb-0">
                  <template v-slot:label>
                    <i class="uil uil-link me-1"></i> External Registration URL *
                  </template>
                  <b-form-input
                    id="externalRegistrationUrl"
                    v-model="event.external_registration_url"
                    type="url"
                    placeholder="https://example.com/register"
                  ></b-form-input>
                  <small class="text-muted">Users will be redirected to this URL to register</small>
                  <validationMessages
                    v-if="submitted"
                    :fieldName="'External Registration URL'"
                    :validationName="$v.event.external_registration_url">
                  </validationMessages>
                </b-form-group>
              </div>
            </div>
          </div>

          <div v-if="!externalRegistration" class="card mb-3">
                <div class="card-body py-2">
                    <h4 class="card-title mb-1">  <i class="uil uil-users-alt me-2"></i>Capacity & Limits</h4>
                    <p class="text-muted mb-3">Set attendance restrictions for the event</p>
                    <div class="row">
                        <div class="col-md-4">
                          <b-form-group label-for="userLimit" class="mb-3">
                            <template v-slot:label>
                              <i class="uil uil-users-alt me-1"></i> Max per user
                            </template>
                            <b-form-input v-model="event.user_limit" placeholder="e.g., 1"></b-form-input>
                            <small class="text-muted">Tickets per person</small>
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group label-for="companyLimit" class="mb-3">
                            <template v-slot:label>
                              <i class="uil uil-building me-1"></i> Max per Company
                            </template>
                            <b-form-input v-model="event.company_limit" placeholder="e.g., 10"></b-form-input>
                            <small class="text-muted">Tickets per company</small>
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group label-for="eventLimit" class="mb-3">
                            <template v-slot:label>
                              <i class="uil uil-users-alt me-1"></i> Total Capacity
                            </template>
                            <b-form-input v-model="event.event_limit" placeholder="e.g., 100"></b-form-input>
                            <small class="text-muted">Maximum attendees</small>
                            <validationMessages
                                v-if="submitted"
                                :fieldName="'Event Limit'"
                                :validationName="$v.event.event_limit">
                            </validationMessages>
                         </b-form-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                          <label class="mb-1">
                            <i class="uil uil-calendar-alt me-1"></i>Register By Date
                          </label>
                          <div class="position-relative">
                            <flat-pickr
                              ref="registerByDatePicker"
                              v-model="registerByDate"
                              :config="registerByDateConfig"
                              class="form-control pe-4"
                              name="register_by_date"
                            />
                            <i class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                               style="cursor: pointer; pointer-events: all;"
                               @click="openRegisterByDatePicker"></i>
                          </div>
                          <small class="text-muted">Deadline for registration</small>
                        </div>
                        <div class="col-md-4">
                          <label class="mb-1">
                            <i class="uil uil-clock me-1"></i>Register By Time
                          </label>
                          <div class="position-relative">
                            <flat-pickr
                              ref="registerByTimePicker"
                              v-model="registerByTime"
                              :config="timeconfig"
                              class="form-control pe-4"
                              name="register_by_time"
                            />
                            <i class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                               style="cursor: pointer; pointer-events: all;"
                               @click="openRegisterByTimePicker"></i>
                          </div>
                        </div>
                    </div>
                </div>
           </div>

          <BusinessNewsAudienceTargeting ref="audienceTargeting" entity-label="business event" />

        <div v-if="!externalRegistration" class="card mb-3">
          <div class="card-body py-2">
            <h4 class="card-title mb-1">Additional Information Fields</h4>

            <!--<p class="text-muted mb-3">Collect custom information from attendees during registration</p>
             <div class="row justify-content-center">
               <div class="col-12">
                 <button
                   type="button"
                   class="btn"
                   @click="addAdditionalFields"
                   style="
                     background: #f8f9fa;
                     border: 1px dashed #dee2e6;
                     color: #495057;
                     border-radius: 6px;
                     padding: 8px 16px;
                     transition: background-color 0.2s;
                     width: 100%;
                     display: block;
                     text-align: center;
                   "
                   @mouseenter="$event.target.style.background = '#e9ecef'"
                   @mouseleave="$event.target.style.background = '#f8f9fa'"
                >
                    <i class="uil uil-plus me-1"></i>Add Another Field
                </button>
       </div>
             </div>-->
        <div id="additional-fields-container">
             <div v-for="(section, index) in additional_sections" :key="section._id" class="mb-3">
               <!-- Saved compact view -->
               <div v-if="savedSections[index]" class="card border saved-field">
                 <div class="card-body p-3 d-flex align-items-center">
                   <div class="drag-handle me-3" style="cursor: move;">
                     <i class="uil uil-bars" style="font-size: 18px; color: #6c757d;"></i>
     </div>
                   <div class="flex-grow-1 font-weight-bold">{{ section.label || 'Untitled Field' }}</div>
                   <button type="button" class="btn btn-sm btn-light" @click="expandField(index)">
                     <i class="uil uil-edit me-1"></i>Edit
                   </button>
                   <button type="button" class="btn btn-sm btn-danger ms-2" @click="removeSection(index)">
                     <i class="uil uil-trash-alt"></i>
                   </button>
                 </div>
               </div>

               <!-- Expanded edit form -->
               <div v-else class="no-drag p-3 rounded mb-3" style="border: 1px solid #dee2e6; background-color: #fff;">
                 <div class="row">
                   <div class="col-md-6">
                     <b-form-group label="Field Label *">
                       <b-form-input v-model="section.label" placeholder="e.g., Dietary Requirements" />
                       <validationMessages
                         v-if="submitted && $v.additional_sections.$each && $v.additional_sections.$each[index]"
                         :fieldName="'Label'"
                         :validationName="$v.additional_sections.$each[index].label"
                       />
                     </b-form-group>
                   </div>

                   <div class="col-md-6">
                     <b-form-group label="Field Type">
                       <div class="d-flex gap-2">
                     <b-form-select
                       v-model="section.field_type"
                       :options="additional_field_options"
                       @change="onFieldTypeChange(section)"
                           class="flex-grow-1"
                           :disabled="!additional_field_options || additional_field_options.length === 0"
                         >
                           <template #first>
                             <option :value="null" disabled>Select field type...</option>
                           </template>
                         </b-form-select>

                       </div>
                     <validationMessages
                         v-if="submitted && $v.additional_sections.$each && $v.additional_sections.$each[index] && $v.additional_sections.$each[index].field_type"
                         :fieldName="'Field Type'"
                         :validationName="$v.additional_sections.$each[index].field_type"
                     />
                     </b-form-group>
                   </div>

                   <div class="col-md-12">
                   <!-- Dynamic Params -->
                   <div v-if="section.field_attributes">
                    <div v-for="(value, key) in section.field_attributes" :key="key">
                      <input v-if="key === 'rows'" type="hidden" v-model="section.field_attributes[key]" />
                      <b-form-group v-else :label="getParamDescription(section, key)" class="mb-3">
                         <!-- Array values -->
                         <div v-if="Array.isArray(value)">
                           <div v-for="(opt, i) in value" :key="i" class="d-flex mb-2">
                             <b-form-input
                               v-model="section.field_attributes[key][i]"
                               placeholder="Enter option"
                             />
                             <b-button
                               v-if="section.field_attributes[key].length > 1"
                               size="sm"
                               variant="danger"
                               class="ml-2"
                               @click="section.field_attributes[key].splice(i,1)"
                             >  <i class="uil uil-trash-alt"></i>
                             </b-button>
                           </div>
                           <b-button size="sm" variant="success" @click="section.field_attributes[key].push('')">
                             <i class="mdi mdi-plus me-2"></i> Add option
                           </b-button>
                         </div>

                         <!-- Single value -->
                         <div v-else>
                           <b-form-input
                             v-model="section.field_attributes[key]"
                             :type="detectInputType(section, key)"
                               :placeholder="key === 'placeholder' ? 'Helper text for users...' : ''"
                           />
                         </div>
                       </b-form-group>
                       </div>
                     </div>

                     <div class="d-flex align-items-center justify-content-between">
                       <b-form-checkbox-group>
                         <span class="ms-2">Required field</span>
                         <div class="form-check form-switch form-switch-lg mb-0">
                           <input
                             v-model="section.required"
                             type="checkbox"
                             class="form-check-input"
                             :true-value="1"
                             :false-value="0"
                           />
                         </div>
                       </b-form-checkbox-group>
                       <button type="button" class="btn btn-primary" @click="saveAdditionalField(index)">
                         <i class="uil uil-check"></i> Save
                       </button>
                     </div>
                   </div>
                 </div>
                     </div>
                   </div>
                </div>

                 <!-- Add new section -->
                 <div class="row mt-2">
                    <div class="col-12">
                        <button 
                          type="button" 
                          class="btn" 
                          @click="addSection"
                          style="
                            background: #f8f9fa;
                            border: 1px dashed #dee2e6;
                            color: #495057;
                            border-radius: 6px;
                            padding: 8px 16px;
                            transition: background-color 0.2s;
                            width: 100%;
                            display: block;
                            text-align: center;
                          "
                          @mouseenter="$event.target.style.background = '#e9ecef'"
                          @mouseleave="$event.target.style.background = '#f8f9fa'"
                        >
                          <i class="uil uil-plus me-1"></i>Add New Field
                        </button>
                    </div>
                 </div>

                 <!-- Tip banner -->
                 <div class="mt-3 p-3 rounded" style="background-color: #e3f2fd; border: 1px solid #90caf9;">
                   <div class="d-flex align-items-center">
                     <i class="uil uil-lightbulb-alt me-2" style="color: #fdd835; font-size: 20px;"></i>
                     <div>
                       <strong style="color: #1976d2;">Tip:</strong>
                       <span style="color: #1976d2;"> Fields will appear in this order during event registration. Drag to reorder.</span>
                     </div>
                   </div>
                 </div>
            </div>
        </div>

        <div v-if="!externalRegistration" class="card mb-3">
          <div class="card-body py-2">
            <h4 class="card-title mb-1">
              <i class="uil uil-file-alt me-2"></i>Terms & Conditions
            </h4>
            <p class="text-muted mb-3">Link to event terms and conditions</p>
            <b-form-group label="Terms & conditions URL" label-for="toc" class="mb-3">
              <b-form-input v-model="event.toc"></b-form-input>
              <small class="text-muted">Attendees will be required to accept these terms during registration</small>
<!--                <validationMessages-->
<!--                    v-if="submitted"-->
<!--                    :fieldName="'Terms and Conditions'"-->
<!--                    :validationName="$v.event.toc">-->
<!--                </validationMessages>-->
            </b-form-group>
          </div>
        </div>

        <div class="row">
            <b-form-group label="Description" label-for="description" class="mb-3">
                <template>
                    <ckeditor :editor="editor" v-model="content" :config="editorConfig"></ckeditor>
                </template>
                <validationMessages
                        v-if="submitted"
                        :fieldName="'Description'"
                        :validationName="$v.content">
                </validationMessages>
            </b-form-group>
        </div>
         <input type="hidden" name="content_type" v-model="content_type">
         <input type="hidden" name="csrf_token" v-model="csrf_token">

         <!-- Validation summary -->
         <div v-if="submitted && validationErrors.length" class="alert alert-danger mt-3">
           <ul>
             <li v-for="(error, i) in validationErrors" :key="i">{{ error }}</li>
           </ul>
         </div>
           <br>
        </div>

        <!-- Right side: mobile phone live preview -->
        <div class="col-lg-5 mt-3 mt-lg-0 preview-sticky-col">
          <div class="card preview-sticky-wrap" style="box-shadow: none;">
            <div class="card-body py-2 d-flex flex-column">
              <h4 class="card-title mb-1">
                <i class="uil uil-mobile-android me-2"></i>Live Mobile Preview
              </h4>
              <p class="text-muted mb-3">
                See how your event will look on a phone as you fill the form.
              </p>

              <div class="flex-grow-1 d-flex align-items-center justify-content-center">
                <div style="width: 100%; display: flex; justify-content: center;">
                  <div
                    style="
                      width: 310px;
                      max-width: 100%;
                      border-radius: 32px;
                      border: 2px solid #e5e7eb;
                      padding: 14px;
                      background: #0b1120;
                      position: relative;
                    "
                  >
                    <!-- App area -->
                    <div
                      style="
                        border-radius: 22px;
                        overflow: hidden;
                        background: #f3f4f6;
                        color: #111827;
                        font-size: 13px;
                        display: flex;
                        flex-direction: column;
                        min-height: 420px;
                      "
                    >
                      <!-- Red header bar -->
                      <div
                        :style="{
                          background: appButtonColor,
                          color: '#fff',
                          textAlign: 'center',
                          padding: '33px 12px',
                          fontWeight: '700',
                          fontSize: '15px',
                          letterSpacing: '0.12em',
                          textTransform: 'uppercase',
                          height: '60px',
                        }"
                      >
                        BUSINESS NEWS
                      </div>

                      <!-- Content card -->
                      <div style="padding: 10px 10px 12px 10px;">
                        <div
                          style="
                            background: #ffffff;
                            border-radius: 16px;
                            overflow: hidden;
                          "
                        >
                          <!-- Image area -->
                          <div v-if="image">
                            <img :src="image" alt="Preview" style="width: 100%; height: 130px; object-fit: cover;">
                          </div>
                          <div
                            v-else
                            style="
                              height: 130px;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              background: #e5e7eb;
                              color: #6b7280;
                              font-size: 12px;
                            "
                          >
                            Header image preview
                          </div>

                          <!-- Top content: title, location, date + dummy users -->
                          <div
                            style="
                              padding: 10px 12px 6px;
                              border-bottom: 1px solid #f3f4f6;
                              display: flex;
                              justify-content: space-between;
                              align-items: flex-start;
                              gap: 8px;
                            "
                          >
                            <!-- Text block -->
                            <div style="flex: 1 1 auto; min-width: 0;">
                              <div
                                style="
                                  font-weight: 700;
                                  font-size: 14px;
                                  line-height: 1.3;
                                  margin-bottom: 4px;
                                  color: #111827;
                                "
                              >
                                {{ title || 'Business trip Sevilla' }}
                              </div>
                              <div style="font-size: 11px; color: #6b7280;">
                                <i class="uil uil-map-marker font-size-15 text-secondary me-1"></i>
                                {{ event.location || 'Amsterdam, Netherlands' }}
                              </div>
                              <div style="font-size: 11px; color: #6b7280; margin-top: 2px;">
                                <i class="uil uil-clock me-1 font-size-15"></i>
                                {{ date || '01-01-2026' }}, <span>{{ time || '16:00' }}</span>
                              </div>
                            </div>

                            <!-- Dummy user avatars + counter -->
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                flex-shrink: 0;
                              "
                            >
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  padding-right: 4px;
                                "
                              >
                                <div
                                  style="
                                    width: 22px;
                                    height: 22px;
                                    border-radius: 9999px;
                                    background: linear-gradient(135deg, #fee2e2, #fecaca);
                                    border: 2px solid #ffffff;
                                    box-shadow: 0 0 0 1px #e5e7eb;
                                  "
                                ></div>
                                <div
                                  style="
                                    width: 22px;
                                    height: 22px;
                                    border-radius: 9999px;
                                    background: linear-gradient(135deg, #e0f2fe, #bae6fd);
                                    border: 2px solid #ffffff;
                                    box-shadow: 0 0 0 1px #e5e7eb;
                                    margin-left: -8px;
                                  "
                                ></div>
                                <div
                                  style="
                                    width: 22px;
                                    height: 22px;
                                    border-radius: 9999px;
                                    background: linear-gradient(135deg, #ede9fe, #ddd6fe);
                                    border: 2px solid #ffffff;
                                    box-shadow: 0 0 0 1px #e5e7eb;
                                    margin-left: -8px;
                                  "
                                ></div>
                              </div>
                              <div
                                style="
                                  background: #e30613;
                                  color: #ffffff;
                                  border-radius: 9999px;
                                  padding: 2px 6px;
                                  font-size: 10px;
                                  font-weight: 700;
                                  line-height: 1;
                                  min-width: 26px;
                                  text-align: center;
                                "
                              >
                                10+
                              </div>
                            </div>
                          </div>

                          <!-- Description text below header -->
                          <div
                            class="preview-description"
                            :class="{ 'preview-description--compact': previewAdditionalFields.length }"
                          >
                            <div v-if="content" v-html="content"></div>
                            <div v-else>
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec in odio ut leo vestibulum porttitor non quis dolor.
                            </div>
                          </div>

                          <!-- Additional registration fields preview -->
                          <div
                            v-if="previewAdditionalFields.length"
                            class="preview-additional-fields"
                          >
                            <!-- <div class="preview-additional-fields__title">
                              Additional information
                            </div> -->
                            <div
                              v-for="section in previewAdditionalFields"
                              :key="`${section._id}-${section.field_type}`"
                              class="preview-field text-muted"
                            >
                              <label class="preview-field__label">
                                {{ section.label || 'Untitled Field' }}
                                <span v-if="section.required" class="preview-field__required">*</span>
                              </label>

                              <!-- Short text -->
                              <input
                                v-if="previewInputType(section) === 'text'"
                                type="text"
                                class="preview-field__control"
                                :placeholder="getPreviewFieldPlaceholder(section) || 'Enter text...'"
                                disabled
                              />

                              <!-- Long text -->
                              <textarea
                                v-else-if="previewInputType(section) === 'textarea'"
                                class="preview-field__control preview-field__control--textarea"
                                :rows="getPreviewTextareaRows(section)"
                                :placeholder="getPreviewFieldPlaceholder(section) || 'Enter text...'"
                                disabled
                              ></textarea>

                              <!-- Radio buttons -->
                              <div
                                v-else-if="previewInputType(section) === 'radio'"
                                class="preview-field__options preview-field__options--radio"
                              >
                                <label
                                  v-for="(option, optionIndex) in getPreviewFieldOptions(section)"
                                  :key="optionIndex"
                                  class="preview-field__option preview-field__option--radio"
                                >
                                  <input
                                    type="radio"
                                    :name="'preview-radio-' + section._id"
                                    :value="option"
                                    v-model="previewFieldValues[section._id]"
                                  />
                                  <span>{{ option }}</span>
                                </label>
                                <div
                                  v-if="!getPreviewFieldOptions(section).length"
                                  class="preview-field__placeholder"
                                >
                                  Add options to preview
                                </div>
                              </div>

                              <!-- Dropdown -->
                              <select
                                v-else-if="previewInputType(section) === 'select'"
                                class="preview-field__control"                               
                              >
                                <option value="">
                                  {{ getPreviewFieldOptions(section).length ? 'Select an option...' : 'Add options to preview' }}
                                </option>
                                <option
                                  v-for="(option, optionIndex) in getPreviewFieldOptions(section)"
                                  :key="optionIndex"
                                  :value="option"
                                >
                                  {{ option }}
                                </option>
                              </select>

                              <!-- Multiselect -->
                              <div
                                v-else-if="previewInputType(section) === 'multi_select'"
                                class="preview-field__options preview-field__options--multi"
                              >
                                <label
                                  v-for="(option, optionIndex) in getPreviewFieldOptions(section)"
                                  :key="optionIndex"
                                  class="preview-field__option preview-field__option--checkbox"
                                >
                                  <input
                                    type="checkbox"
                                    :value="option"
                                    v-model="previewFieldValues[section._id]"
                                  />
                                  <span>{{ option }}</span>
                                </label>
                                <div
                                  v-if="!getPreviewFieldOptions(section).length"
                                  class="preview-field__placeholder"
                                >
                                  Add options to preview
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Sign up button -->
                      <div
                        style="
                          padding: 0 10px 10px 10px;
                          margin-top: auto;
                          display: flex;
                          justify-content: center;
                        "
                      >
                        <div
                          :style="{
                            background: appButtonColor,
                            color: appButtonTextColor,
                            fontWeight: '700',
                            fontSize: '13px',
                            padding: '9px 80px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.16em'
                          }"
                        >
                          <span
                            style="
                              display: inline-block;
                            "
                          >
                            SIGN UP
                          </span>
                        </div>
                      </div>

                      <!-- Bottom solid red bar (no icons) -->
                      <div
                        :style="{
                            background: appButtonColor,
                            height: '50px'
                        }"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      </form>
        <br>
        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="addBusinessEvent" :disabled="tryingToSubmit">
                <b-spinner v-show="tryingToSubmit" small></b-spinner>
                Submit</b-button>
        </template>

    </b-modal>
</template>

<style scoped>
.sortable-ghost {
  opacity: 0.5;
}

/* Lighten placeholder text color */
::placeholder,
input::placeholder,
textarea::placeholder {
  color: #adb5bd !important;
  opacity: 1;
}

/* For Bootstrap Vue form inputs */
.form-control::placeholder {
  color: #adb5bd !important;
  opacity: 1;
}

/* For flatpickr inputs */
.flatpickr-input::placeholder {
  color: #adb5bd !important;
  opacity: 1;
}

@media (min-width: 992px) {
  .preview-sticky-col {
    position: relative;
  }

  .preview-sticky-wrap {
    position: -webkit-sticky;
    position: sticky;
    top: 20px;
  }
}

.preview-description {
  padding: 6px 12px 12px;
  font-size: 12px;
  color: #4b5563;
  max-height: 200px;
  overflow-y: auto;
}

.preview-description--compact {
  max-height: 100px;
}

.preview-additional-fields {
  padding: 0 12px 12px;
  border-top: 1px solid #f3f4f6;
}

.preview-additional-fields__title {
  font-size: 11px;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 10px 0 8px;
}

.preview-field {
  margin-bottom: 10px;
  margin-top: 10px;
}

.preview-field:last-child {
  margin-bottom: 0;
}

.preview-field__label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.preview-field__required {
  color: #e30613;
  margin-left: 2px;
}

.preview-field__control {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 6px 8px;
  font-size: 11px;
  color: #6b7280;
  background: #f9fafb;
}

.preview-field__control--textarea {
  resize: none;
  min-height: 56px;
}

.preview-field__options {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.preview-field__option {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 11px;
  color: #4b5563;
}

.preview-field__option input {
  margin: 0;
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  cursor: pointer;
}

.preview-field__option--radio input[type="radio"] {
  accent-color: #e30613;
}

.preview-field__option--checkbox input[type="checkbox"] {
  accent-color: #e30613;
  border-radius: 3px;
}

.preview-field__options--radio .preview-field__option,
.preview-field__options--multi .preview-field__option {
  cursor: pointer;
}

.preview-field__placeholder {
  font-size: 11px;
  color: #9ca3af;
  font-style: italic;
}
</style>